import { render, staticRenderFns } from "./step6-id.vue?vue&type=template&id=0d8a5cea&scoped=true&"
import script from "./step6-id.vue?vue&type=script&lang=js&"
export * from "./step6-id.vue?vue&type=script&lang=js&"
import style0 from "./step6-id.vue?vue&type=style&index=0&id=0d8a5cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8a5cea",
  null
  
)

export default component.exports